// App.jsx
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import Loader from './components/Loader';
// Pages
import Home from './components/pages/Home';
import Switchgear from './components/pages/Switchgear';
import Automobile from './components/pages/Automobile';
import About from './components/pages/About'
import Switchyard from './components/pages/Switchyard';
import ScrollToHashElement from './components/ScrollToHashElement';

function AnimatedApp() {
  const location = useLocation();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const timeout = setTimeout(() => setLoading(false), 1800); // Match total loader time
    return () => clearTimeout(timeout);
  }, [location.pathname]);

  return (
    <>
     <ScrollToHashElement/>
      {loading && <Loader key={location.pathname} />}
      {!loading && (
       
        <>
        <Routes location={location} key={location.pathname}>
           
          <Route path="/" element={<Home />} />
           <Route path="/about" element={<About />} />
          <Route path="/automobile" element={<Automobile />} />
          <Route path="/switchyard" element={<Switchyard />} />
          <Route path="/switchgear" element={<Switchgear />} />
        
        </Routes>

       <ScrollToHashElement/>
       </>
      )}
    </>
  );
}

export default function AppWrapper() {
  return (
    <Router>
      <AnimatedApp />
    </Router>
  );
}
